<template>
  <div class="task-widget" @click="onClick">
    <div class="task-image" :title="title">
      <img :style="{
        width: size + 'px',
        height: size + 'px',
      }" src="@/assets/admin-icon/menu/tasks.svg" />
    </div>

    <div class="task-widget-content">
      <span class="title" v-if="title">
        {{ $validateString(title) | validate }}
      </span>
      <span class="subtitle" v-if="subtitle">
        {{ subtitle | validate }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget-task-viewer",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    file_name: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
    show_name: {
      type: Boolean,
      default: true,
    },
    size: {
      type: Number,
      default: 18,
    },
    text_size: {
      type: Number,
      default: 12,
    },
    showContent: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() { },
  methods: {
    $validateString(val) {
      return val.replaceAll("null", "");
    },
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>
<style lang="scss" scoped>
.task-widget {
  display: flex;
  align-items: center;

  .task-image {
    margin-right: 8px;

    img {
      height: 25px;
      width: 25px;
      padding: 5px;
      background: #1ba5a4;
      border-radius: 50%;
    }
  }

  .task-widget-content {
    display: flex;
    align-items: center;

    .title {
      color: #000000;
      font-weight: 600;
      font-size: 12px;
      margin-right: 16px;
    }

    .subtitle {
      color: #c4c4c4;
      font-size: 11px;
    }
  }

  &.active {
    .task-alphabet {
      background: #fff;
      border: 1px solid #0884af;
      color: #0884af;
    }
  }
}
</style>
